const article = {
  slug: 'gate-codes',
  title: 'Gate codes',
  section: 'Operations',
  body: `
# Gate codes

## How a tenant gets a code

The gate-code email fires when the move-in **payment succeeds** - not
when the lease is signed. The code resolves in this order:

1. The customer's own gate code, if set on the customer record.
2. Otherwise the unit's gate code.

- Code on file -> tenant gets the "rental confirmed + gate code" email.
- No code anywhere -> tenant gets a confirmation asking them to contact
  the office.

## Changing codes

Update the code on the customer (preferred) or unit record. Gate
hardware integrations are configured under Settings -> Integrations
where available; otherwise codes are managed in your gate software and
mirrored here for the emails.

> Tenant says "I never got my code": confirm payment actually succeeded
> first - an unpaid tenant is gated by design, even with a signed lease.
`,
};

export default article;
